import errModal from 'views/common/errorModal.html'
class resultTipService {
    constructor($uibModal) {
        this.$uibModal = $uibModal
    }
    openErrorModal(params, callback) {
        this.$uibModal.open({
            template: errModal,
            controller: ['$scope', '$uibModalInstance', 'params', ($scope, $uibModalInstance, params) => {
                params.successCount = params.sourceCount - params.errorCount
                $scope.params = params
                $scope.cancel = function () {
                    $uibModalInstance.close()
                }
            }],
            backdrop: 'static',
            openedClass: 'mod-modal-importexcel mod-modal mod-modal-lg',
            windowClass: 'mod-modal mod-modal-lg',
            bindToController: true,
            resolve: {
                params() {
                    return params
                },
            },
        }).result.then(() => {
            callback && callback()
        })
    }
}
resultTipService.$inject = ['$uibModal']
export default resultTipService


// WEBPACK FOOTER //
// ./src/common/services/resultTipService.js